import axios from 'axios';

export const initAxiosInterceptors = () => {
  axios.interceptors.request.use((config) => {
    if (config?.useBaseUrl !== false) {
      config.url = `${process.env.REACT_APP_API_BASE}${config.url}`;
    }
    if (config.auth) {
      const token = localStorage.getItem('access-token');
      if (!token) throw new Error('token not found');
      config.headers = {
        ...config.headers,
        'access-token': token,
      };
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        localStorage.clear();
        window.location.replace('/login');
      }
      throw { data: error?.response?.data, status: error?.response?.status };
    }
  );
};
